var _g, _path, _g2, _path2, _g3, _path3, _path4, _path5, _path6, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWastes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13227_36325)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#06513D",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13227_36325",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 12,
    width: 6,
    height: 5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3369 12.667V15.8848H29.874V12.667H33.3369Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13227_36325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6055 12.6787H31.6084C32.4061 12.6776 33.0691 13.2856 33.1514 14.0732L33.1592 14.2334C33.1538 15.0908 32.4579 15.7825 31.6084 15.7812H31.6055C30.7461 15.7826 30.05 15.0895 30.042 14.2344C30.0464 13.372 30.7439 12.6774 31.6055 12.6787Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13227_36325",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 16,
    width: 16,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8965 17.2178V38.2695H21.874V17.2178H35.8965Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13227_36325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9961 17.7471H33.9395C35.0093 17.7455 36.0136 18.5264 36.0137 19.9238V26.5674C36.0137 26.7646 35.9506 26.8546 35.9082 26.8955C35.858 26.9439 35.7825 26.9761 35.6943 26.9756C35.6065 26.975 35.5288 26.9419 35.4756 26.8896C35.4411 26.8557 35.3959 26.7923 35.375 26.6758L35.3633 26.541V19.792H33.5986V37.4912C33.5972 37.7425 33.5109 37.8757 33.4258 37.9512C33.3288 38.0371 33.1815 38.0929 33.0117 38.0898C32.842 38.0867 32.6885 38.0247 32.584 37.9277C32.4899 37.8405 32.401 37.6941 32.4004 37.4375V26.9189H30.584V37.4541C30.584 37.7093 30.4978 37.8506 30.4092 37.9326C30.31 38.0244 30.1627 38.0823 29.998 38.084C29.8331 38.0857 29.6889 38.0307 29.5938 37.9453C29.5101 37.8701 29.4258 37.7378 29.4258 37.4912L29.4111 20.5381L29.4092 18.4355L28.1992 20.1543L26.6729 22.3213L26.6592 22.3428C26.6335 22.3824 26.5945 22.4165 26.5352 22.4424C26.4718 22.47 26.3957 22.4833 26.3262 22.4824H22.3086C22.1726 22.4828 22.1089 22.4371 22.0723 22.3965C22.0253 22.3443 21.9887 22.2582 21.9873 22.1562C21.986 22.0548 22.0196 21.9776 22.0596 21.9336C22.0895 21.9007 22.1593 21.8438 22.3359 21.8438H26.1602L26.3584 21.5547L28.3516 18.6494C28.5936 18.3035 28.8339 18.0863 29.0811 17.9521C29.3258 17.8194 29.6173 17.7463 29.9961 17.7471Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5713 29.9736V30.2598H21.2725V29.9736H21.5713Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1689 27.3281L21.9316 27.5684L21.6914 27.3281L21.9316 27.0908L22.1689 27.3281Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0654 25.0977L20.8232 25.3398L20.5811 25.0977L20.8232 24.8584L21.0654 25.0977Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13227_36325",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 27,
    width: 11,
    height: 12
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4082 27.8799V38.2715H17.667V27.8799H26.4082Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13227_36325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0391 28.2002L19.7383 37.3008L19.8398 37.8457H23.6865L23.79 37.3047L25.54 28.2002H25.7627L23.9121 38.0781H19.6309L17.8008 28.2002H18.0391Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13227_36325",
    x: 0.8,
    y: 0.8,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13227_36325"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13227_36325",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWastes);
export default __webpack_public_path__ + "static/media/Wastes.de73cfadb4b93be0a3f8ec205054705e.svg";
export { ForwardRef as ReactComponent };